var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01,34.11c0,.59,.32,1.13,.84,1.4l20.29,10.81s.1,.04,.15,.06l.16,.06c.35,.11,.57,.09,.84,.02l.13-.05c.12-.04,.17-.06,.22-.08l20.29-10.81c.52-.28,.84-.81,.84-1.4V13.83c0-.14-.02-.27-.05-.41l-.04-.11c-.03-.1-.07-.2-.12-.28l-.09-.12c-.06-.09-.11-.15-.16-.21l-.21-.17s-.05-.05-.08-.07l-.11-.07L24.64,1.61c-.23-.12-.49-.19-.75-.19s-.5,.06-.73,.18L2.87,12.12c-.53,.27-.86,.81-.86,1.4,.01,.05,.02,.09,.02,.12v.16l-.02,20.31Zm40.57-.95l-17.1,9.12V25.59l3.64-1.94v8.86c0,.38,.24,.74,.6,.87,.35,.14,.78,.03,1.03-.25l4-4.45,3.07,.41c.28,.03,.54-.05,.74-.22,.2-.18,.32-.44,.32-.7v-9.72l3.7-1.97v16.68Zm-11.59-3.09v-7.41l6.01-3.21v7.65l-2.5-.34c-.32-.04-.61,.07-.82,.3l-2.69,3ZM23.88,4.81l16.88,8.99-3.16,1.64L20.72,6.45l3.16-1.64Zm-5.17,2.68l16.88,8.99-5.87,3.05L12.83,10.54l5.88-3.05Zm-7.89,4.09l16.88,8.99-3.79,1.97L7.02,13.55l3.79-1.97Zm-5.62,4.89l17.1,9.12v16.68L5.19,33.16V16.48Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPackages);
export default __webpack_public_path__ + "static/media/icon_packages.f1cc8977f85586bc3b470ea3cec5b025.svg";
export { ForwardRef as ReactComponent };